import {schema} from "normalizr";

export const schemas={};

// add ref schemas
const createSchemaRefs = meta => {
    Object.keys(meta.entities).map(e => {
        Object.keys(meta.entities[e].properties).map(p => {
            const ref = meta.entities[e].properties[p].ref;
            if (ref) {
                schemas[e].schema[ref] = schemas[ref];
            }
        });
    });
}

export const createSchemas = meta => {
    Object.keys(meta.entities).map(e => {
        schemas[e] = new schema.Entity(
            e,
            {},
            {
                idAttribute: meta.entities[e].identity,
            }
        );

    });
    createSchemaRefs(meta);
}




// WEBPACK FOOTER //
// ./src/utils/schemas.js